import XId from "../base/data/XId";


/**
 * 
 * @param id 
 * @returns 
 */
export const getBillUrl = (id:string|null) : string|null => id? "https://go.xero.com/AccountsPayable/View.aspx?invoiceID="+id : null;

export const getInvoiceUrl = (id:string|null) : string|null => id? "https://go.xero.com/AccountsReceivable/View.aspx?invoiceID="+id : null;

/**
 * 
 * @param id Can be a plain id or an XId (HACK for older data - plain id preferred)
 * @returns 
 */
export const getXeroContactUrl = (id:string|null) : string|null => id? "https://go.xero.com/Contacts/View/"+(XId.isa(id)? XId.id(id) : id) : null;
